<template>
    <div class="regtable__pagerfanta pagerfanta" v-if="lastPage > 1">
        <a v-if="currentPage > 1" href="#" @click.prevent="$emit('change', currentPage - 1)">&lt;</a>
        <span v-else class="disabled">&lt;</span>

        <template v-for="page in pages" :key="page">
            <span v-if="page === '...'" class="dots">&hellip;</span>
            <span v-else-if="page === currentPage" class="current">{{ page }}</span>
            <a v-else href="#" @click.prevent="$emit('change', page)">{{ page }}</a>
        </template>

        <a v-if="currentPage < lastPage" href="#" @click.prevent="$emit('change', currentPage + 1)">&gt;</a>
        <span v-else class="disabled">&gt;</span>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    currentPage: { type: Number, required: true },
    lastPage: { type: Number, required: true },
});

defineEmits(['change']);

// Mirrors Pagerfanta\View\DefaultView's proximity window - current page +/-
// a few neighbours, plus the first/last page, with "..." gaps between.
const PROXIMITY = 3;

const pages = computed(() => {
    const result = [];
    let previous = 0;
    for (let page = 1; page <= props.lastPage; page++) {
        const isEdge = page === 1 || page === props.lastPage;
        const isNear = Math.abs(page - props.currentPage) <= PROXIMITY;
        if (isEdge || isNear) {
            if (previous && page - previous > 1) {
                result.push('...');
            }
            result.push(page);
            previous = page;
        }
    }
    return result;
});
</script>
